import {withTranslation} from "react-i18next";
import React, {useEffect, useRef, useState} from "react";
import {Avatar, Button, Fade, IconButton, makeStyles, Modal, Snackbar, Typography} from '@material-ui/core';
import {useDispatch, useSelector} from "react-redux";
import {poolActions} from "../../../redux/actions/poolActions";
import {walletActions} from "../../../redux/actions/walletActions";
import {roundingDown} from "../../../utils/RoundingDown";
import {removeLiquidity} from '../../../utils/Sign'
import CustomTextField from "../../CommonElements/CustomTextField";
import CloseIcon from "@material-ui/icons/Close";
import {getIcons} from "../../../utils/Common";
const confirmIcon = 'https://demobanner.api-sands.com/Icons/swapIcon.png'

const RemoveLiquidity = (props) => {
    const {
        onCancel: handleClose,
        modalVisible,
        values,
        address,
        chainId,
        currentWallet,
        web3,
        t
    } = props;
    const [amount1, setAmount1] = useState("");
    const [amount2, setAmount2] = useState("");
    const amount1All = useRef(false);
    const amount2All = useRef(false);
    const [inputFocused, setInputFocused] = React.useState(false)
    const [resultViewVisible, setResultViewVisible] = useState(false);
    const [submitDisable, setSubmitDisable] = useState(true);
    const [snackBarVisible, setSnackBarVisible] = useState(false);
    const [amount1Warning, setAmount1Warning] = useState('');
    const [amount2Warning, setAmount2Warning] = useState('');
    const useStyles = makeStyles((theme) => ({
        modal: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        paper: {
            position: 'absolute',
            width: 400,
            backgroundColor: theme.palette.background.paper,
            border: '2px solid #000',
            boxShadow: theme.shadows[5],
            padding: theme.spacing(2, 4, 3),
        }
    }));
    const classes = useStyles();
    const { tokenIcons } = useSelector(state => state.wallet)
    const { myLiquidityPools, removeLiquidityQuote, removeLiquidityQuoteLoading, poolSigning } = useSelector(state => state.pool)
    const { token } = useSelector(state => state.auth)
    const dispatch = useDispatch();
    const pool = myLiquidityPools.find(item => item.token1 === values.token1 && item.token2 === values.token2);

    useEffect(() => {
        // dispatch(poolActions.removeLiquidityQuote({
        //     poolId: pool.poolId,
        //     token: pool.token1,
        //     amount: '0',
        //     accessToken:token
        // }))
        dispatch(poolActions.clearRemoveQuote())
        dispatch(walletActions.getUserCapital(token))
        return () => {
        }
    }, [])

    useEffect(() => {
        if (!inputFocused && amount1 > 0 && amount2 > 0 && amount1 <= pool.availableUnStaked1 && amount2 <= pool.availableUnStaked2) {
            setSubmitDisable(false)
        } else {
            setSubmitDisable(true)
        }
        if (amount1 <= 0 && amount1 != "") {
            setAmount1Warning(t('invalidInput'))
        } else if (amount1 > pool.availableUnStaked1) {
            setAmount1Warning(t('insufficient_fund'))
        } else {
            setAmount1Warning("")
        }
        if (amount2 <= 0 && amount2 != "") {
            setAmount2Warning(t('invalidInput'))
        } else if (amount2 > pool.availableUnStaked2) {
            setAmount2Warning(t('insufficient_fund'))
        } else {
            setAmount2Warning("")
        }
        if (amount1All.current) {
            amount1All.current = false;
            dispatch(poolActions.removeLiquidityQuote({
                poolId: pool.poolId,
                token: pool.token1,
                amount: amount1,
                accessToken: token
            }))
        } else if (amount2All.current) {
            amount2All.current = false;
            dispatch(poolActions.removeLiquidityQuote({
                poolId: pool.poolId,
                token: pool.token2,
                amount: amount2,
                accessToken: token
            }))
        }
        return () => {
        }
    }, [amount1, amount2, myLiquidityPools])

    useEffect(() => {
        dispatch(poolActions.getMyLiquidityPool(token))
        if (removeLiquidityQuote.token === pool.token1) {
            setAmount1(roundingDown(removeLiquidityQuote.amount, 8))
        } else if (removeLiquidityQuote.token === pool.token2) {
            setAmount2(roundingDown(removeLiquidityQuote.amount, 8))
        } else{
            setAmount1("")
            setAmount2("")
        }
        return () => {
        }
    }, [removeLiquidityQuote])

    const handleSubmit = async () => {
        setResultViewVisible(true)
        await removeLiquidity(address, chainId, currentWallet, web3, dispatch, poolSigning, pool.token1, pool.token2, removeLiquidityQuote.lpAmount, setAmount1, setAmount2, token, handleClose, setSnackBarVisible)
        setResultViewVisible(false)
    }

    const handleChange = (event) => {
        if (event.target.name === "amount1") {
            setAmount1(event.target.value)
        } else if (event.target.name === "amount2") {
            setAmount2(event.target.value)
        }
    };

    const handleSnackClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setSnackBarVisible(false);
    };

    const resultViewBody = (

        <div style={{
            backgroundColor: '#F5F5F5', borderRadius: 24, width: 480, overflow: 'hidden', outline: 0, display: 'flex', alignItems: 'center', flexDirection: 'column'
        }}>

            <Avatar src={confirmIcon} variant="square" style={{ height: 54 * 1.2, width: 77 * 1.2, marginTop: 24 }} />

            <Typography style={{ fontSize: 16, fontWeight: 'bold', marginTop: 8, color: '#251CFF' }}>
                {t('pool-confirm-title')}
            </Typography>
            <Typography style={{ fontSize: 12, fontWeight: 'bold', marginTop: -4, color: '#8786A7' }}>
                {t('pool-confirm-content')}
            </Typography>

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '89%', marginTop: 40 }}>
                <Typography style={{ fontSize: 14, color: '#363636', fontWeight: 'bold' }}>
                    {t('pool-removeLiquidity-remove')}
                </Typography>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Avatar alt="Travis Howard" src={getIcons(pool.token1, tokenIcons, true)} style={{ height: 20, width: 20, }} />
                    <Typography style={{ fontSize: 14, color: '#363636', fontWeight: 'bold', marginRight: 8 }} >
                        {amount1 +" " +pool.token1}
                    </Typography>

                    <Avatar alt="Travis Howard" src={getIcons(pool.token2, tokenIcons, true)} style={{ height: 20, width: 20, }} />
                    <Typography style={{ fontSize: 14, color: '#363636', fontWeight: 'bold' }} >
                        {amount2 + " "+pool.token2}
                    </Typography>
                </div>
            </div>

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 8, width: '89%' }}>
                <Typography style={{ fontSize: 14, color: '#363636', fontWeight: 'bold' }}>
                    {t('pool-removeLiquidity-fee')}
                </Typography>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Typography style={{ fontSize: 14, color: '#363636', fontWeight: 'bold' }} >
                        {roundingDown(removeLiquidityQuote.fee1,8) + " " + pool.token1} + {roundingDown(removeLiquidityQuote.fee2,8) + " " + pool.token2}
                    </Typography>
                </div>
            </div>

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 8, width: '89%' }}>
                <Typography style={{ fontSize: 14, color: '#363636', fontWeight: 'bold' }}>
                    {t('price')}
                </Typography>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Typography style={{ fontSize: 14, color: '#363636', fontWeight: 'bold' }} >
                        1 {pool.token1} = {roundingDown(removeLiquidityQuote.ratioPerToken1ToToken2, 8)} {pool.token2}
                    </Typography>


                </div>
            </div>

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 8, width: '89%', marginBottom: 40 }}>
                <Typography style={{ fontSize: 14, color: '#363636', fontWeight: 'bold' }}>
                    {t('pool-destroyed')}
                </Typography>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Typography style={{ fontSize: 14, color: '#363636', fontWeight: 'bold' }} >
                        {pool.token1}-{pool.token2}-LP: {roundingDown(removeLiquidityQuote.lpAmount, 8)}
                    </Typography>
                </div>
            </div>

            {removeLiquidityQuote.fee1 != 0 && removeLiquidityQuote.fee2 !=0 ?
                <Typography style={{ fontSize: 12, fontWeight: 'bold', color: '#363636', textAlign: 'center',  marginBottom: 40 }}>
                    {t('pool-removeLiquidity-feeMessage')}
                </Typography>
                : null
            }

        </div>
    );

    const removeLiquidityBody = (
        <div style={{
            backgroundColor: '#F5F5F5', borderRadius: 24, width: 600, alignItems: 'center', overflow: 'hidden', outline: 0
        }}>
            <div style={{ display: 'flex', flexDirection: 'row', paddingTop: 40, alignItems: 'center', justifyContent: 'space-between' }}>
                <div style={{ marginLeft: 24 }}>
                    {/* <Typography style={{ fontSize: 16, fontWeight: 'bold', color: '#FF5151' }}>{t('pool-removeLiquidity')}</Typography> */}
                    <Typography style={{ fontSize: 14, fontWeight: 'bold', color: '#251CFF' }}>{pool.token1}-{pool.token2}</Typography>
                    <Typography style={{ fontSize: 12, fontWeight: '600', color: '#363636', marginTop: -4 }}>
                        {t('price')}: 1 {pool.token1} = {roundingDown(removeLiquidityQuote.ratioPerToken1ToToken2, 8)} {pool.token2}
                    </Typography>
                </div>

                <div style={{ flexDirection: 'row', display: 'flex', backgroundColor: 'white', height: 48, alignItems: 'center', width: 100, justifyContent: 'space-between', borderRadius: 24, marginRight: 24 }}>
                    <Avatar src={getIcons(pool.token1, tokenIcons, true)} style={{ height: 32, width: 32, marginLeft: 12 }} />
                    <Avatar src={getIcons(pool.token2, tokenIcons, true)} style={{ height: 32, width: 32, marginRight: 12 }} />
                </div>
            </div>

            {/* <img src={poolPopTopBG} style={{ width: 400, height: 120, borderTopRightRadius: 24, borderTopLeftRadius: 24, opacity: 0.5 }}>
            </img> */}
            <div style={{ marginLeft: 24, marginRight: 24, }}>

                <Typography style={{ fontSize: 16, fontWeight: '600', color: '#FF5151', marginTop: 24 ,marginBottom:24}}>
                    {t('pool-destroyed')+ " " + pool.token1}-{pool.token2}-LP: {roundingDown(removeLiquidityQuote.lpAmount, 8)}
                </Typography>
                <CustomTextField
                    id="amount1"
                    name="amount1"
                    label={
                        pool.availableUnStaked1 ?
                            pool.token1 + " "+ t('pool-removeLiquidity-removableAmount') +": " + roundingDown(pool.availableUnStaked1, 4) + " " + pool.token1
                            :
                            t('pool-removeLiquidity-no') + pool.token1 + t('pool-removeLiquidity-removableAmount')
                    }
                    disabled={removeLiquidityQuoteLoading}
                    style={{ width: '100%', textTransform: 'none' }}
                    onChange={handleChange}
                    value={amount1}
                    helperText={amount1Warning}
                    error={amount1Warning !== ''}
                    rightbuttonlabel={t('all')}
                    onrightbuttondisable={inputFocused || removeLiquidityQuoteLoading}
                    onrightbuttonclick={() => {
                        if (roundingDown(pool.availableUnStaked1, 8) != amount1){
                            amount1All.current = true
                            setAmount1(roundingDown(pool.availableUnStaked1, 8))
                        }
                    }}
                    onFocus={()=>{
                        setInputFocused(true)
                    }}

                    onBlur={() => {
                        setInputFocused(false)
                        dispatch(poolActions.removeLiquidityQuote({
                            poolId: pool.poolId,
                            token: pool.token1,
                            amount: amount1,
                            accessToken: token
                        }))
                    }}
                    customtype="number"
                >
                </CustomTextField>
                <div style={{height:24}}></div>
                <CustomTextField
                    id="amount2"
                    name="amount2"
                    label={

                        pool.availableUnStaked2 ?
                            pool.token2 +" "+ t('pool-removeLiquidity-removableAmount') + ": " + roundingDown(pool.availableUnStaked2, 4) + " " + pool.token2
                            :
                            t('pool-removeLiquidity-no') + pool.token2 + t('pool-removeLiquidity-removableAmount')
                    }
                    disabled={removeLiquidityQuoteLoading}
                    style={{ width: '100%', textTransform: 'none' }}
                    onChange={handleChange}
                    value={amount2}
                    helperText={amount2Warning}
                    error={amount2Warning !== ''}
                    rightbuttonlabel={t('all')}
                    onrightbuttondisable={inputFocused || removeLiquidityQuoteLoading}
                    onrightbuttonclick={() => {
                        if(roundingDown(pool.availableUnStaked2, 8) != amount2){
                            amount2All.current = true
                            setAmount2(roundingDown(pool.availableUnStaked2, 8))
                        }
                    }}
                    onFocus={()=>{
                        setInputFocused(true)
                    }}

                    onBlur={() => {
                        setInputFocused(false)
                        dispatch(poolActions.removeLiquidityQuote({
                            poolId: pool.poolId,
                            token: pool.token2,
                            amount: amount2,
                            accessToken: token
                        }))
                    }}
                    customtype="number"
                >
                </CustomTextField>
                {removeLiquidityQuote.fee1 != 0 && removeLiquidityQuote.fee2 !=0 ?
                    <div>
                        <Typography style={{ fontSize: 12, fontWeight: '600', color: '#8FB9E1' }}>
                            {t('pool-removeLiquidity-fee')}: {roundingDown(removeLiquidityQuote.fee1,8) + " " + pool.token1} + {roundingDown(removeLiquidityQuote.fee2,8) + " " + pool.token2}
                        </Typography>
                        <Typography style={{ fontSize: 12, fontWeight: 'bold', color: '#8FB9E1', textAlign: 'left', marginTop: 40 }}>
                            {t('pool-removeLiquidity-feeMessage')}
                        </Typography>
                    </div>
                    : null
                }
            </div>

            <div style={{ display: 'flex', alignItems: 'flex-end', flexDirection: 'column', marginTop: 40, width: '100%' }}>
                <Button
                    // variant="outlined"
                    onClick={handleSubmit}
                    disabled={submitDisable}
                    style={{ backgroundColor: '#FF5151', width: "100%", height: 60, borderRadius: 0 }}
                >

                    <Typography style={{ fontSize: 16, fontWeight: 'bold', color: 'white' }}>

                        {t('pool-removeLiquidity')}
                        </Typography>

                </Button>


            </div>
            {/*确认页*/}
            <Modal
                open={resultViewVisible}
                onClose={() => {
                    if (!poolSigning) {
                        setResultViewVisible(false)
                    }
                }}
                className={classes.modal}
            >
                {resultViewBody}
            </Modal>
            {/*取消签名提示框*/}
            <Snackbar
                open={snackBarVisible}
                onClose={handleSnackClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                autoHideDuration={5000}
                TransitionComponent={Fade}
                message={t('actionCancelled')}
                key={"cancelSign"}
                action={
                    <React.Fragment>
                        <IconButton size="small" aria-label="close" color="inherit" onClick={handleSnackClose}>
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    </React.Fragment>
                }
            />
        </div >
    );

    return (
        <Modal
            open={modalVisible}
            onClose={() => {
                dispatch(poolActions.clearRemoveQuote())
                handleClose()
            }}
            className={classes.modal}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
        >
            {removeLiquidityBody}
        </Modal>
    )
}

export default withTranslation()(RemoveLiquidity);
